import common from './common'
import account from './account'
import accountPayable from './accountPayable'
import businessLicense from './businessLicense'
import mortgage from './mortgage'
import vendorMWorker from './vendorMWorker'
import approval from './approval'
import auth from './auth'
import checkApproval from './checkApproval'
import gardenerAP from './gardenerAP'
import approvalHistory from './approvalHistory'
import contractor from './contractor'
import maintenance from './maintenance'
import menu from './menu'
import propertyManagement from './propertyManagement'
import role from './role'
import settings from './settings'
import stateCountyCity from './stateCountyCity'
import employeesInformation from './employeesInformation'
import managerWorkTime from './managerWorkTime'
import holidayCalendar from './holidayCalendar'
import employmentTitle from './employmentTitle'
import apliance from './apliance'
import fieldRule from './fieldRule'
import vendorType from './vendorType'
import hardWareStore from './hardWareStore'
import pendingCheck from './pendingCheck'
import utilPayment from './utilPayment'
import vendor from './vendor'
import report from './report'
import maintenanceMaterial from './maintenanceMaterial'
import appAdvertising from './appAdvertising'
import dashboard from './dashboard'
import operatingStatementMonthsReport from './operatingStatementMonthsReport'
import recordAdjustment from "./recordAdjustment"
import bankRec from "./bankRec"
import bankmortgage from './bankmortgage'
import attendanceManagement from "./attendanceManagement"
import insurance from './insurance'
import monthlyWorkerAP from './monthlyWorkerAP'
import accountReceivable from "./accountReceivable"
import creditCheck from "./creditCheck"
import threeDayNotice from "./threeDayNotice"
import vacancyEvictionBalanceReport from "./vacancyEvictionBalanceReport"

export default {
    ...common,
    ...account,
    ...accountPayable,
    ...businessLicense,
    ...mortgage,
    ...vendorMWorker,
    ...approval,
    ...auth,
    ...checkApproval,
    ...gardenerAP,
    ...approvalHistory,
    ...contractor,
    ...maintenance,
    ...menu,
    ...propertyManagement,
    ...role,
    ...settings,
    ...stateCountyCity,
    ...employeesInformation,
    ...managerWorkTime,
    ...holidayCalendar,
    ...employmentTitle,
    ...apliance,
    ...fieldRule,
    ...vendorType,
    ...hardWareStore,
    ...pendingCheck,
    ...utilPayment,
    ...vendor,
    ...report,
    ...maintenanceMaterial,
    ...appAdvertising,
    ...dashboard,
    ...operatingStatementMonthsReport,
    ...recordAdjustment,
    ...bankRec,
    ...bankmortgage,
    ...attendanceManagement,
    ...insurance,
    ...monthlyWorkerAP,
    ...accountReceivable,
    ...creditCheck,
    ...threeDayNotice,
    ...vacancyEvictionBalanceReport
}
